export enum protocolOrActivityConfigTagCategory {
    BODY_PARTS = 'BODY_PARTS',
    TYPE = 'TYPE',
    MUSCLE = 'MUSCLE',
    MOVEMENT = 'MOVEMENT',
    ANGLE = 'ANGLE',
    PLATES_EXERCISES = 'PLATES_EXERCISES'
}
